<p>
  The information used to populate the Find a Ryan White HIV/AIDS Program (RWHAP) Medical Provider locator tool
  originates from the Ryan White HIV/AIDS Program Services Report (RSR) Provider Report. RSR data are submitted annually
  and capture information on RWHAP funded recipients, subrecipients and clients receiving services in the previous
  calendar year. The provider locator tool displays service delivery site locations for RWHAP funded recipients and
  subrecipient that directly provided outpatient ambulatory health services to RWHAP clients in the previous calendar
  year. Any updates that are made to the RSR Provider Report during the reporting season will be reflected in the
  provider locator tool.
</p>
